namespace RioERP.Masters {
    export interface SmsGatewaySettingsRow {
        Id?: number;
        ApiKey?: string;
        Sender?: string;
        EntityId?: string;
        TemplateId?: string;
        IsActive?: number;
    }

    export namespace SmsGatewaySettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ApiKey';
        export const localTextPrefix = 'Masters.SmsGatewaySettings';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ApiKey = "ApiKey",
            Sender = "Sender",
            EntityId = "EntityId",
            TemplateId = "TemplateId",
            IsActive = "IsActive"
        }
    }
}
